'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.magazine.objectFit', []);

_module.directive('cbObjectFitV1', cbObjectFitV1);

exports.default = _module;


function cbObjectFitV1() {
    return {
        restrict: 'C',
        scope: true,
        controller: ['$element', function controller($element) {
            var vm = this;

            var initialWidth = $element[0].querySelector('img').width,
                initialHeight = $element[0].querySelector('img').height,
                aspect = initialWidth / initialHeight;

            window.picturefill = {};

            var raf = function () {
                return window.requestAnimationFrame || function (callback) {
                    window.setTimeout(callback, 10);
                };
            }();

            var setImages = function setImages() {
                raf(function () {
                    /* Add background image */
                    var img = $element[0].querySelector('img');
                    $element[0].style.height = img.height + 'px';

                    /* Add class */
                    $element.addClass('object-fit-active');

                    var src = img.currentSrc || img.src;
                    $element[0].style.backgroundImage = 'url(' + src + ')';
                });
            };

            var resizeImages = function resizeImages() {
                var currentWidth = $element[0].clientWidth,
                    newHeight = currentWidth / aspect;

                $element[0].style.height = newHeight + 'px';
            };

            if (/MSIE|Trident/.test(navigator.userAgent)) {
                var checkExist = setInterval(function () {
                    if (window.picturefill) {
                        clearInterval(checkExist);
                        raf(setImages);
                        $(window).on('resize', resizeImages);
                    }
                }, 100);
            }
        }]
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/magazine/object-fit/object-fit.js
// module id = 841
// module chunks = 0